export const applicationConstants = {
  TOGGLE__SIDEBAR_MENU: 'TOGGLE__SIDEBAR_MENU',
  SET_SUBMITTED_STATE: 'SET_SUBMITTED_STATE',
  START_CREATING: 'START_CREATING',
  SUCCESS_CREATING: 'SUCCESS_CREATING',
  FAIL_CREATING: 'FAIL_CREATING',
  RESET_ERROR: 'RESET_ERROR',
  RESET_APP_STORE: 'RESET_APP_STORE',
};
